export const webConfigs = {
  width: 1620,
  height: 800,
  gameCharacterConfigs: {
    crazyWormSceneConfigs: {
      crazyWormConfig: { x: 260, y: 710, scale: 0.24 },
      shootSmokeConfig: { x: 350, y: 690, scale: 0.24 },
    },
  },
  get applicationConfigs() {
    return { width: this.width, height: this.height };
  },
};

export const mobileConfigs = {
  width: 780,
  height: 1150,
  gameCharacterConfigs: {
    crazyWormSceneConfigs: {
      crazyWormConfig: { x: 128, y: 770, scale: 0.174 },
      shootSmokeConfig: { x: -25, y: 820, scale: 0.22 },
    },
  },
  get applicationConfigs() {
    return { width: this.width, height: this.height };
  },
};
